import { render, staticRenderFns } from "./printInstock.vue?vue&type=template&id=1a8f4894&scoped=true&"
import script from "./printInstock.vue?vue&type=script&lang=js&"
export * from "./printInstock.vue?vue&type=script&lang=js&"
import style0 from "./printInstock.vue?vue&type=style&index=0&id=1a8f4894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f4894",
  null
  
)

export default component.exports